<template>
  <div class="stop-dialog">
    <img class="icon" src="@/assets/images/icon-warning.png" alt="">
    <p class="tips">计划停止后，策略同时执行如下操作</p>
    <div class="check-box">
      <Checkbox v-model="checkData.isClose" class="item" @change="changeCheck" shape="square">平仓</Checkbox>
      <Checkbox v-model="checkData.isCancel" class="item" @change="changeCheck" shape="square">撤单</Checkbox>
    </div>
  </div>
</template>

<script>
import { Checkbox } from "vant";
export default {
  model:{
    prop: "checkData",
    event: "changeCheck"
  },
  props: {
    checkData: {
      type: Object,
      default: function(){
        return {
          isClose: true,
          isCancel: true
        }
      }
    }
  },
  components: {
    Checkbox
  },
  methods: {
    changeCheck(){
      this.$emit("changeCheck", this.checkData)
    }
  }
}
</script>

<style scoped lang="less">
  .stop-dialog{
    .icon{
      display: block;
      margin: 70px auto 40px;
      width: 126px;
      height: 120px;
    }
    .tips{
      font-size: 28px;
      text-align: center;
    }
    .check-box{
      display: flex;
      align-items: center;
      justify-content: center;
      margin: 40px 0;
      font-size: 24px;
      .item{
        margin: 0 20px;
      }
    }
  }
</style>
